import GraphQL from '@app/model/_common/service/GraphQL';
import { gql } from 'graphql-request';

export const RUN_COMPANY_HOTELS_INFO_MUTATION: GraphQL = {
	name: 'runCompanyHotelsInfo',
	gql: gql`
      mutation runCompanyHotelsInfo($companyHotelId:Long!) {
          runCompanyHotelsInfo(companyHotelId: $companyHotelId) {
              exception
              success
          }
      }
	`,
};

export const FINISH_COMPANY_HOTELS_INFO_MUTATION: GraphQL = {
	name: 'finishCompanyHotelsInfo',
	gql: gql`
      mutation finishCompanyHotelsInfo {
          finishCompanyHotelsInfo {
              success
              exception
          }
      }
	`,
};

export const RUN_COMPANY_HOTEL_RANKING_MUTATION: GraphQL = {
	name: 'runCompanyHotelsRanking',
	gql: gql`
      mutation runCompanyHotelsRanking($companyHotelId:Long!) {
          runCompanyHotelsRanking(companyHotelId: $companyHotelId) {
              success
              exception
          }
      }
	`,
};

export const FINISH_COMPANY_HOTELS_RANKING_MUTATION: GraphQL = {
	name: 'finishCompanyHotelsRanking',
	gql: gql`
      mutation finishCompanyHotelsRanking {
          finishCompanyHotelsRanking {
              success
              exception
          }
      }
	`,
};

export const FIND_COMPANY_SETTINGS_QUERY: GraphQL = {
	name: 'findCompanySettings',
	gql: gql`
		query findCompanySettings {
        findCompanySettings {
						enableAddCompanyHotel
						enableIntegrationSettings
        }
		}
	`
}
export const FIND_COMPANY_DEPARTMENTS_QUERY: GraphQL = {
	name: 'findCompanyDepartments',
	gql: gql`
		query findCompanyDepartments {
				findCompanyDepartments {
						id
						name
						creationDate
        }
		}
	`
}

export const SAVE_COMPANY_DEPARTMENT_MUTATION: GraphQL = {
	name: 'saveCompanyDepartment',
	gql: gql`
			mutation saveCompanyDepartment($input:CompanyDepartmentInput!) {
        saveCompanyDepartment(input: $input) {
						id
						name
            creationDate
        }
		}
	`
}

export const REMOVE_COMPANY_DEPARTMENT_MUTATION: GraphQL = {
	name: 'removeCompanyDepartment',
	gql: gql`
		mutation removeCompanyDepartment($departmentId:Long!) {
        removeCompanyDepartment(departmentId: $departmentId) {
						success
						exception
        }
		}
	`
}